import { useIntl } from "react-intl";
import FormField from "components/molecules/FormField/FormField";

function OtherDescription({ isRequired }: { isRequired: boolean }) {
  const intl = useIntl();
  return (
    <div className="pt-1">
      <FormField
        label={intl.formatMessage({
          id: "new-request.packing-list.additionalField",
          defaultMessage: "Additional field",
        })}
        type="textinput"
        field_id="additional_field"
        mandatory={isRequired}
        containerClasses="ml-2"
      />
    </div>
  );
}

export default OtherDescription;
